import React, { useEffect, useState } from 'react'
import { CustomButton, FilterBar, TableData } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { setConciliacionesHistory } from '../../redux/slices/report/reportSlice';
import { getConciliacionHistoryService } from '../../services/report/reportService';
import { errorAlert } from '../../helpers/alerts';
import moment from 'moment';
import ConciliationLogModal from 'components/modal/ConciliationLogModal';
import { ListAlt, Replay, ReplayCircleFilled } from '@mui/icons-material';
import { getAllProviderCredsService } from 'services/admin/providerService';
import { retrySingleConcilliation } from 'services/admin/conciliacionService';
import { setLoading } from 'redux/slices/uiSlice';
import useFilterBar from 'hooks/useFilterBar';

const ConciliacionHistoryScreen = () => {
  const dispatch = useDispatch();
  const { conciliacionesHistory } = useSelector(store => store.reports);
  const [localLoading, setLocalLoading] = useState(false)
  const [current, setCurrent] = useState(null)
  const [providerCreds, setProviderCreds] = useState(null)
  const { submit } = useFilterBar();


  const columns_diferencias = [
    { name: "provider", label: "Proveedor", format: ({ connectorName }) => connectorName },
    { name: "cred", label: "Instancia", format: ({ cred }) => cred.name_connector },
    { name: "message", label: "Mensaje", format: ({ message }) => message },
    { name: "positive", label: "Estatus", format: ({ status }) => status || '-' },
    { name: "createdAt", label: "Creación", format: ({ createdAt }) => (new Date(createdAt)).toLocaleString() },
    { name: "updatedAt", label: "Ejecución", format: ({ updatedAt }) => (new Date(updatedAt)).toLocaleString() },
  ]
  useEffect(() => {
    getAllProviderCredsService().then(creds => {
      let list = creds.filter(item => item.provider && !['smartgateiso', 'jano', 'certificacion'].includes(item.conciliacion_service));
      setProviderCreds(list);
    }).catch(error => errorAlert(error))
      .finally(() => setLocalLoading(false));
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = async (data) => {
    setLocalLoading(true)
    getConciliacionHistoryService(data)
      .then((response) => dispatch(setConciliacionesHistory(response || [])))
      .catch((e) => errorAlert(e))
      .finally(() => setLocalLoading(false));
  }

  const handlerRetryConciliation = async (data) => {
    dispatch(setLoading(true))
    retrySingleConcilliation({ id: data._id, date: moment(data.createdAt).subtract(1, 'day').valueOf() })
      .then(() => submit())
      .catch((e) => errorAlert(e))
      .finally(() => dispatch(setLoading(false)));
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        defaultValues={{
          date: moment().toDate()
        }}
        filters={[
          {
            type: "month",
            name: "date",
            label: "Fecha",
          },
          {
            name: "cred",
            label: "Instancia",
            type: "select",
            data: providerCreds?.map(item => ({
              id: item.id,
              name: item.name_connector,
            })) || [],
            loading: providerCreds == null,
          },
        ]}
      />
      <TableData
        headerButtons={[
          // <CustomButton
          //   dark={true}
          //   icon={<ReplayCircleFilled />}
          //   key="retryConciliation"
          //   name={"Reintentar conciliación"}
          // click={() => setShowColumnFilterModal(true)}
          // />
        ]}
        loading={localLoading}
        dataRows={conciliacionesHistory || []}
        dataTitle={columns_diferencias.map(({ label }) => label)}
        formatter={(data) => columns_diferencias.map(({ format }) => format(data))}
        actions={[
          {
            icon: <Replay />,
            label: 'Reintentar conciliación',
            onClick: (data) => handlerRetryConciliation(data),
            validate: (data) => data.status === 'Error'

          },
          {
            icon: <ListAlt />,
            label: 'Ver log',
            onClick: (data) => setCurrent(data._id)
          }
        ]}
      />
      <ConciliationLogModal
        id={current}
        open={Boolean(current)}
        onClose={() => setCurrent(null)}
      />
    </>

  )
}

export default ConciliacionHistoryScreen